







import {
  Component,
  Emit,
  Inject,
  Model,
  Prop,
  Provide,
  Vue,
  Watch
} from "vue-property-decorator";
import { Action, Getter, namespace } from "vuex-class";
@Component({
  name: "TextItem"
})
export default class TextItem extends Vue {
  // 查询form
  @Prop({
    default: () => {
      return {};
    }
  })
  public formParam: any;
  @Prop({
    default: () => {
      return {};
    }
  })
  private config: any;
  private get itemData() {
    return this.config.render
      ? this.config.render(this.formParam)
      : this.formParam[this.config.value];
  }
}
